"use strict";

require("core-js/modules/es.object.assign");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buildConsoleLogger = buildConsoleLogger;
exports.ConsoleLogger = void 0;

var _contracts = require("./contracts");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var ConsoleLogger = /*#__PURE__*/function () {
  function ConsoleLogger(context) {
    _classCallCheck(this, ConsoleLogger);

    this.context = context;
  }

  _createClass(ConsoleLogger, [{
    key: "formatMessage",
    value: function formatMessage(message, level, context) {
      var msg = '[' + level + ']';

      if (context && context.app) {
        msg += ' ' + context.app + ': ';
      }

      return msg + message;
    }
  }, {
    key: "log",
    value: function log(level, message, context) {
      switch (level) {
        case 0:
          console.debug(this.formatMessage(message, _contracts.LogLevel.Debug, context), context);
          break;

        case 1:
          console.info(this.formatMessage(message, _contracts.LogLevel.Info, context), context);
          break;

        case 2:
          console.warn(this.formatMessage(message, _contracts.LogLevel.Warn, context), context);
          break;

        case 3:
          console.error(this.formatMessage(message, _contracts.LogLevel.Error, context), context);
          break;

        default:
          console.error(this.formatMessage(message, _contracts.LogLevel.Fatal, context), context);
          break;
      }
    }
  }, {
    key: "debug",
    value: function debug(message, context) {
      this.log(0, message, Object.assign({}, this.context, context));
    }
  }, {
    key: "info",
    value: function info(message, context) {
      this.log(1, message, Object.assign({}, this.context, context));
    }
  }, {
    key: "warn",
    value: function warn(message, context) {
      this.log(2, message, Object.assign({}, this.context, context));
    }
  }, {
    key: "error",
    value: function error(message, context) {
      this.log(3, message, Object.assign({}, this.context, context));
    }
  }, {
    key: "fatal",
    value: function fatal(message, context) {
      this.log(4, message, Object.assign({}, this.context, context));
    }
  }]);

  return ConsoleLogger;
}();

exports.ConsoleLogger = ConsoleLogger;

function buildConsoleLogger(context) {
  return new ConsoleLogger(context);
}
//# sourceMappingURL=ConsoleLogger.js.map